import ClosableModal from './component.jsx'
export default ClosableModal
